import composer, { type optionPairType } from "./composer";

export default (option: optionPairType) =>
  composer(option, "checkbox", {
    fieldLabel: "Encrypt This Field",
    fieldValue: false,
  });
